import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { transactionPaymentCategory_template } from "../components/templates/transactionPaymentCategory_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class transaction_payment_category extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: transactionPaymentCategory_template;


    protected getModuleName(): string {

      return "transaction_payment_category";
    }

    buildContent(): Array<Element> {

        this.elementsList = new transactionPaymentCategory_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Transaction Payment Categories");

        return [this.elementsList.build()];
    }

    public fillPage() {

        this.filterList();
    }

    public getActiveSystem() {
        return this.elementsList.getSystem();
    }


    protected startLoading(){
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("transaction-payment-systems-list-results"));
    }

    protected endLoading(){
        this.loadingOut(this.elementsList.builtTemplate.children.namedItem("transaction-payment-systems-list-results"));
    }

    protected filterList() {

        debugger;
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.startLoading();

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transaction/payment-categories/get/';
        let usrReq_params: Array<Array<string>> = [];
        let viewModelForRequest = this.elementsList.getGetRequestData();

        usrReq_params.push(["data", ko.toJSON(viewModelForRequest)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.endLoading();
            });
        }
    }

    protected updateList(data: any){
        this.elementsList.setTransactionPaymentCategoriesFromServer(data);
    }

    protected save(){

        this.startLoading();

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transaction/payment-categories/save/';
        let usrReq_params: Array<Array<string>> = [];
        let paymentCategoriesToSave = this.elementsList.getPostRequestData();
        usrReq_params.push(["data", ko.toJSON(paymentCategoriesToSave)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSavePaymentCategoriesRequestReturn;
        this.XHRHdl.execute();
    }

    protected onSavePaymentCategoriesRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){
              obj.filterList();
              obj.validationTemplate.clearMessages();
          });
          obj.endLoading();
      }
    }

    public getIdBrand() {
      return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/transaction_payment_category.ts